import { exec, getApiToken } from '../utils';
import type {
  GetSearchFacetsArgs,
  GetSearchFacetsExecVariables,
  SearchFacetsResponse,
  GetSearchFacetsExecResponse
} from '@src/types';

export const getSearchFacets = async (args: GetSearchFacetsArgs): Promise<SearchFacetsResponse> => {
  const { partnerCode, token, query, filters } = args;
  const apiToken = await getApiToken(token);

  const searchFacetsQuery = `
    query catalogManagementSearchFacets(
      $partnerCode: String
      $token: String!
      $query: String!
      $filters: [FacetLimitPublic]
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          catalogManagementSearchShop {
            searchFacets(query: $query, filters: $filters) {
              tag
              title
              entries {
                name
                count
              }
            }
          }
        }
      }
    }
  `;

  const data = await exec<GetSearchFacetsExecVariables, GetSearchFacetsExecResponse>(
    searchFacetsQuery,
    {
      variables: {
        partnerCode,
        token: apiToken,
        query: query || '',
        filters: filters || [],
      },
    },
  );

  return data.restUser.partner.catalogManagementSearchShop;
};
